import React from 'react'
import Navbar from '../../navbar/Navbar'
import "./India.css"
function India() {
  return (
    <>
    <Navbar/>
      <div class='container body'>
            <div class='container-fluid'>
                 <section class="contact_us">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <div class="contact_inner">
                                        <div class="row">
                                            <div class="col-md-10">
                                                <div class="contact_form_inner">
                                                    <div class="contact_field">
                                                        <h3 class="gh1">India Contact</h3>
                                                        <form action="https://formsubmit.co/1f9de97eaef43ecde446c163a7da0e83" method="POST">
                                                        <input type="text" class="form-control form-group" placeholder="Name" required/>
                                                        <input type="email" class="form-control form-group" placeholder="Email" required/>
                                                        <input type="number" class="form-control form-group" placeholder="Phone Number" required/>
                                                        <input type="text" class="form-control form-group" placeholder="Grade" required/>
                                                        <textarea style={{height:"8rem"}} class="form-control form-group" placeholder="Message" required></textarea>
                                                        <button class="contact_form_submit" type='submit'>Send</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="right_conatct_social_icon d-flex align-items-end">
                                                <div class="socil_item_inner d-flex">
                                                    <li><a href="#"><i class="fab fa-facebook-square"></i></a></li>
                                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="contact_info_sec">
                                            <h4>Contact Info</h4>
                                            <div class="d-flex info_single align-items-center">
                                                <i class="fas fa-headset"></i>
                                                <span>SCO 142-143, Jupor Group Building, D Block, Ranjit Avenue, Amritsar, India</span>
                                            </div>
                                            <div class="d-flex info_single align-items-center">
                                                <i class="fas fa-headset"></i>
                                                <span>+91 77105 00044</span>
                                            </div>
                                            <div class="d-flex info_single align-items-center">
                                                <i class="fas fa-envelope-open-text"></i>
                                                <span>info@jupor.in</span>
                                            </div>
                                            <div class="d-flex info_single align-items-center">
                                                <i class="fas fa-map-marked-alt"></i>
                                                <span>We understand that each student's situation and needs are unique to them . Tell us more about what you're looking for, and we will back to you soon with a customized plan according to your needs.</span>
                                            </div>
                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    
                    <section class="map_sec">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <div class="map_inner">
                                        <h4>Find Us on Google Map</h4>
                                        <div class="map_bind">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3396.2101775886667!2d74.85278821508258!3d31.655469081325034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39196522554710eb%3A0xd360467e7425accd!2sJUPOR%20Group%20of%20Companies!5e0!3m2!1sen!2sin!4v1680245235982!5m2!1sen!2sin" width="100%" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                <div/> 

                </div>

      </div>
    </>
  )
}
export default India
